import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {HttpClient} from "@angular/common/http";
import {catchError, of, retryWhen, switchMap, throwError} from "rxjs";
import {HeaderService} from "./header.service";
import {HelperService} from "./helper.service";

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private apiUrls = [environment.baseUrl];
  private currentUrlIndex = 0;
  constructor(
      private _header: HeaderService,
      private _helper: HelperService,
      private _http: HttpClient,
  ) { }

  apiUrl(url:any,endpoint: string) {
    return url + endpoint;
  }

  private getNextUrl() {
    this.currentUrlIndex = (this.currentUrlIndex + 1) % this.apiUrls.length;
    return this.apiUrls[this.currentUrlIndex];
  }

  private requestWithFailover<T>(requestFn: (url: string) => any) {
    return requestFn(this.apiUrls[this.currentUrlIndex]).pipe(
        catchError(error => {
          const nextUrl = this.getNextUrl();
          if (nextUrl === this.apiUrls[0]) {
            return throwError(error); // All URLs failed, propagate error
          }
          return of(null).pipe(switchMap(() => requestFn(nextUrl))); // Retry with next URL
        }),
        retryWhen(errors => errors.pipe(
            switchMap(error => {
              const nextUrl = this.getNextUrl();
              if (nextUrl === this.apiUrls[0]) {
                return throwError(error); // All URLs failed, propagate error
              }
              return of(null); // Retry with next URL
            })
        ))
    );
  }

  /**
   * Summery: Post method for admin : set admin header
   * @param endPoint
   * @param reqData
   */
  post(endPoint: any, reqData: any, showErrorToast: boolean = true){
    return this.requestWithFailover(url => this._http.post(this.apiUrl(url,endPoint),reqData,this._header.getHeader()).pipe(catchError((x) => this._helper.handleAuthError(x, showErrorToast))))
  }
}
